import request from '@/plugins/axios'

export function submitInformation (data) {
  return request({
    url: '/service-info-provider/v1/information/new',
    method: 'post',
    data
  })
}

// 获取视频信息
export async function getVideoInfo (num) {
  const result = await request({
    baseURL: '/',
    url: '/video/v.json',
    method: 'get'
  })

  const datas = result.data

  let getNum = num
  if (num === 'all') {
    getNum = datas.length
  }

  return datas.slice(0, getNum)
}

// 获取问题信息
export async function getQuestionAndAnswer () {
  const result = await request({
    baseURL: '/',
    url: '/video/question.json',
    method: 'get'
  })
  return result
}

// 获取算力租赁中服务器信息
export async function getServerInfo () {
  const result = await request({
    baseURL: '/',
    url: '/video/serviceList.json',
    method: 'get'
  })
  return result
}



// WEBPACK FOOTER //
// ./src/api/data.js